import { render } from "./LabelNew.vue?vue&type=template&id=13023133"
import script from "./LabelNew.vue?vue&type=script&lang=js"
export * from "./LabelNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicContainer from "@/components/BasicContainer.vue";
import MainCol from "@/components/MainCol.vue";
import PageFooter from "@/components/PageFooter.vue";
import PageGrid from "@/components/PageGrid.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
script.components = Object.assign({}, { BasicContainer, MainCol, PageFooter, PageGrid, SecondaryNav, SecondaryTop }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicContainer, MainCol, PageFooter, PageGrid, SecondaryNav, SecondaryTop }, script.__o.components);}